export default "__VITE_ASSET__82ce080b__"